module.exports = __webpack_public_path__ + "static/media/3.d6f558c8.jpg";